import { Box, Typography } from "@mui/material";
import { observer } from "mobx-react-lite";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import CloseIcon from "../../../assets/images/icons/CloseIcon";
import LinkConstants from "../../../constants/LinkConstants";
import { POSTHOG_EVENTS } from "../../../constants/PostHogEvents";
import usePostHog from "../../../hooks/usePostHog";
import { useAppStore } from "../../../hooks/useStores";
import BriaButton from "../../common/BriaButton/BriaButton";
import styles from "./AnnouncementBar.module.scss";

/** The release the bar promotes (copy under "announcementBar" in common.json). Set to null to switch it off. */
const ACTIVE_ANNOUNCEMENT: { id: string; href: string } | null = {
	id: "image-expansion",
	href: LinkConstants.BRIA_NEW_PLATFORM_EXPAND_IMAGE_SANDBOX,
};

const AnnouncementBar = () => {
	const { t } = useTranslation("translation", { keyPrefix: "announcementBar" });
	const [showAnnouncementBar, setShowAnnouncementBar] = useState(ACTIVE_ANNOUNCEMENT !== null);
	const { trackEvent } = usePostHog();
	const { authStore } = useAppStore();
	useEffect(() => {
		if (showAnnouncementBar && ACTIVE_ANNOUNCEMENT) {
			trackEvent(POSTHOG_EVENTS.ANNOUNCEMENT_BAR_DISPLAYED, {
				announcement: ACTIVE_ANNOUNCEMENT.id,
				userName: authStore.user?.userName,
			});
		}
	}, [showAnnouncementBar]);
	if (!showAnnouncementBar || !ACTIVE_ANNOUNCEMENT) return null;
	return (
		<>
			<Box className={styles.anouncementBar}>
				<span className={styles.badge}>{t("badge")}</span>
				<Typography className={styles.title}>{t("title")}</Typography>
				<BriaButton
					className={styles.button}
					buttonType="secondarySmall"
					onClick={() => {
						trackEvent(POSTHOG_EVENTS.ANNOUNCEMENT_BAR_CTA_CLICKED, {
							announcement: ACTIVE_ANNOUNCEMENT.id,
							userName: authStore.user?.userName,
						});
						window.open(ACTIVE_ANNOUNCEMENT.href, "_blank");
					}}
				>
					{t("button")}
				</BriaButton>
				<CloseIcon
					className={styles.closeIcon}
					onClick={() => {
						trackEvent(POSTHOG_EVENTS.ANNOUNCEMENT_BAR_DISMISSED, {
							announcement: ACTIVE_ANNOUNCEMENT.id,
							userName: authStore.user?.userName,
						});
						setShowAnnouncementBar(false);
					}}
				/>
			</Box>
		</>
	);
};

export default observer(AnnouncementBar);
